// Front
export * from "./layouts/thunk";

// Authentication
export * from "./auth/login/thunk";
export * from "./auth/register/thunk";
export * from "./auth/forgetpwd/thunk";
export * from "./auth/profile/thunk";

//Calendar
export * from "./calendar/thunk";
//Chat
export * from "./chat/thunk";
//Ecommerce
export * from "./ecommerce/thunk";

//Project
export * from "./projects/thunk";

// Tasks
export * from "./tasks/thunk";
//Crypto
export * from "./crypto/thunk";

//TicketsList
export * from "./tickets/thunk";
//Crm
export * from "./crm/thunk";

//Invoice
export * from "./invoice/thunk";

//Mailbox
export * from "./mailbox/thunk";

// Dashboard Ecommerce
export * from "./dashboardEcommerce/thunk";

// Pages > Team
export * from "./team/thunk";

// File Manager
export * from "./fileManager/thunk";

// To do
export * from "./todos/thunk";

// Jobs
export * from "./jobs/thunk";

// API Key
export * from "./apiKey/thunk";